import { setDefaultOptions } from 'date-fns';
import { ar, enUS, es, fr, it, pt, ru, zhCN } from 'date-fns/locale';
import type { Locale } from 'date-fns';

/**
 * date-fns formats in English until it is told otherwise, which left every
 * month abbreviation and every relative phrase ("about 2 months ago") in
 * English regardless of the chosen language. Setting the default locale once
 * covers every `format` / `formatDistanceToNow` call in the app, so call sites
 * stay untouched.
 */
const DATE_LOCALES: Record<string, Locale> = { en: enUS, es, fr, pt, it, ar, ru, zh: zhCN };

export const applyDateLocale = (language: string) => setDefaultOptions({ locale: DATE_LOCALES[language] ?? enUS });
